export var ThreadMode;
(function (ThreadMode) {
    ThreadMode[ThreadMode["MAIN"] = 0] = "MAIN";
    ThreadMode[ThreadMode["REMOTE"] = 1] = "REMOTE";
})(ThreadMode || (ThreadMode = {}));
export function defineService(id) {
    return id;
}
export function implementService(_, factory) {
    return factory;
}
implementService.withConfig = function () {
    return function (_, factory) {
        return factory;
    };
};
